module.exports = __webpack_public_path__ + "img/icon_map_4_c.3265bc01.png";